export const calculateFileSize = (files = []) => {
  let totalSize = 0;

  files.forEach((file) => {
    totalSize += file.size;
  });

  return totalSize;
};
